// The website language is saved on the user's account, so it follows them to
// any device: chosen language -> account, and on login/page load the
// account's language -> website.
import i18n, { SUPPORTED_LANGUAGES } from "utils/i18n";
import { API_BASE_URL } from "common/apiUrls";
import { getToken } from "utils/auth";

let fromAccount = null; // the language just applied from the account

export function applyAccountLanguage(user) {
  const lng = user && user.language;
  if (!lng || !SUPPORTED_LANGUAGES.includes(lng) || lng === i18n.language)
    return;
  fromAccount = lng;
  i18n.changeLanguage(lng);
}

i18n.on("languageChanged", (lng) => {
  if (lng === fromAccount) {
    fromAccount = null;
    return;
  }
  const token = getToken();
  if (!token || !SUPPORTED_LANGUAGES.includes(lng)) return;
  fetch(`${API_BASE_URL}/me/language`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "x-auth-token": token },
    body: JSON.stringify({ language: lng }),
  }).catch(() => {});
});
